// Where Cognito's logout endpoint lands the user after signing them out
// of the federated session. We show a brief confirmation + a way back in.

export function SignedOutPage() {
  return (
    <main className="mx-auto max-w-3xl px-6 py-16">
      <h1 className="text-2xl font-semibold tracking-tight">Signed out</h1>
      <p className="mt-2 text-slate-600">Your session has been cleared.</p>
      <p className="mt-6">
        <a
          className="text-accent hover:text-accent-hover underline underline-offset-2"
          href="/"
        >
          ← Back to home
        </a>
      </p>
    </main>
  );
}
